<template>
  <div>
    <ADataTable
      :headers="headers"
      :api="api"
      :apiParams="apiParams || apiParamsDefault"
      :sortBy="'ScanTime'"
      :sortDesc="true"
      :hideAutoRefreshBox="true"
      :exportable="exportable"
      :autoRefreshInitVal="autoRefresh"
      @click:row="onRowClick"
      ref="table"
    />
  </div>
</template>


<script>
import snackbarMixin from "../../../mixins/snackbar";
import CRUDFuncsMixin from "../../../mixins/CRUDFuncs";
import ADataTable from "../../../components/ADataTable";
import { time } from "../../../utils"

export default {
  name: "TrackingOrderLog",
  props: ["hideTitleBar", "autoRefresh", "exportable", "apiParams"],
  mixins: [snackbarMixin, CRUDFuncsMixin],
  components: {
    ADataTable
  },
  data: () => ({
    model: "trackingorderlog",
    apiParamsDefault: {
      queryType: "latest"
    },
    headers: [
      { text: "Transfer Order ID", value: "trackingOrderName", sortable: false },
      { text: "Location", value: "locationName", sortable: true },
      { text: "User", value: "scannedByUser", sortable: true },
      { text: "Notes", value: "Notes", sortable: false },
      {
        text: "ScanTime",
        value: "TimestampFormatted",
        cusOrderByName: "scanTime",
        sortable: true,
        format: {
          value: "scanTime",
          formatter: v => {
            return time.toTimestampFormat1(v);
          }
        }
      }
    ]
  }),
  computed: {},
  methods: {
    refresh() {
      this.$refs.table.load();
    },
    onRowClick(ob) {
      //   this.$refs.cartModal.open(ob.CartId);
    }
  }
};
</script>


<style>
</style>

